import { useState } from 'react'
import { createProject } from '../api/client'
import { useUIStore } from '../store/uiStore'
import './NewProjectModal.css'

export default function NewProjectModal({ onCreated }: { onCreated?: () => void }) {
  const isOpen = useUIStore((s) => s.modals.newProject)
  const closeModal = useUIStore((s) => s.closeModal)
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  if (!isOpen) return null

  const handleClose = () => {
    closeModal('newProject')
  }

  const handleSubmit = async () => {
    const n = name.trim()
    if (!n) {
      alert('Please enter a project name.')
      return
    }
    setIsSubmitting(true)
    try {
      await createProject(n, description.trim() || undefined)
      setName('')
      setDescription('')
      closeModal('newProject')
      onCreated?.()
    } catch (e) {
      console.error('Failed to create project:', e)
      alert(`Failed to create project: ${e instanceof Error ? e.message : 'Unknown error'}`)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content new-project-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>New project</h2>
          <button className="modal-close" onClick={handleClose} type="button">
            ×
          </button>
        </div>
        <div className="modal-body">
          <div className="np-field">
            <label>Project name</label>
            <input value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Nuclear risk" />
          </div>
          <div className="np-field">
            <label>Description (optional)</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="What’s this project about?"
              rows={3}
            />
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn-primary" type="button" onClick={handleSubmit} disabled={isSubmitting}>
            {isSubmitting ? 'Creating…' : 'Create project'}
          </button>
          <button className="btn-secondary" type="button" onClick={handleClose} disabled={isSubmitting}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}



